// extracted by mini-css-extract-plugin
module.exports = {"tabWrapper":"Tab_tabWrapper__VSJgt","tab":"Tab_tab__kD5ah","highlightedTab":"Tab_highlightedTab__lSv8J"};